/* eslint-disable */
import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table } from "antd";
// import {
//   onShowSizeChange,
//   itemRender,
// } from "../../_components/paginationfunction";
import useCustomerHook from "./useCustomerHook";
import { CURRENCY_SYMBOLS } from "../../sales/invoices/components/constant";

const Customers = () => {
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const { customers, customersLoading } = useCustomerHook();
  const COMPANY = window?.COMPANY || {};
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const datasource = customers || [];
  const leadStage = [
    { value: "new", label: "New" },
    { value: "technical", label: "Technical" },
    { value: "false_inquiry", label: "False inquiry" },
    { value: "follow_up", label: "Follow up" },
  ];
  const columns = [
    {
      title: "Customer ID",
      dataIndex: "customer_code",
      render: (val) => <span>{val}</span>,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (img, record) => (
        <>
          <h2 className="table-avatar">
            {record?.img && (
              <Link
                to={`/customers/edit-customer/${record.id}`}
                className="avatar avatar-md me-2"
              >
                <img
                  className="avatar-img rounded-circle"
                  src={record?.img}
                  alt="User Image"
                />
              </Link>
            )}
            <Link to={`/customers/edit-customer/${record.id}`}>
              {record.user.full_name} <span>{record.user.email}</span>
            </Link>
          </h2>
        </>
      ),
      sorter: (a, b) => {
        const nameA = a.user.full_name?.toLowerCase() || "";
        const nameB = b.user.full_name?.toLowerCase() || "";
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      },
    },
    {
      title: "Phone",
      dataIndex: "user",
      render: (value, record) => <>{record?.user?.mobile_number}</>,
    },

    {
      title: "Total Invoice",
      dataIndex: "total_invoice_value",
      // sorter: (a, b) => a.Invoice.length - b.Invoice.length,
      sorter: (a, b) =>
        Number(a.total_invoice_value) - Number(b.total_invoice_value),

      render: (val, row) => (
        <span>
          {" "}
          {CURRENCY_SYMBOLS[COMPANY.currency_type]}
          {val}
        </span>
      ),
    },
    {
      title: "Lead Stage",
      dataIndex: "lead_stage",
      render: (text, record) => {
        const value = leadStage.find((stage) => stage.value === text)?.label
        return (
          <span className={value ? "badge bg-success" : ""}>{value || '-'}</span>
        )
      },
    },
    {
      title: "Lead Source",
      dataIndex: "lead_source",
      render: (text, record) => <div>{text || "-"}</div>,
    },
    {
      title: "Created",
      dataIndex: "created_on",
      sorter: (a, b) => new Date(a.created_on) - new Date(b.created_on),
      defaultSortOrder: "descend",
    },

    {
      title: "Action",
      dataIndex: "Action",
      render: (val, record) => (
        <>
          <div className="table-invoice d-flex align-items-center">
            <Link
              to={`/customers/${record.id}/details`}
              className="btn btn-greys me-2"
            >
              <i className="fa fa-plus-circle me-1" /> Details
            </Link>

          </div>
        </>
      ),
    },
    {
      render: (val, record) => (
        <>
          <div className="table-invoice d-flex align-items-center">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className=" btn-action-icon "
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <ul>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={`/customers/edit-customer/${record.id}/`}
                    >
                      <i className="far fa-edit me-2" />
                      Edit
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      data-ba-id={record.id}
                      onClick={() => setShow(record.id)}
                    >
                      <i className="far fa-trash-alt me-2" />
                      Delete
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </>
      ),
      // sorter: (a, b) => a.Action.length - b.Action.length,
    },
  ];

  // Function to handle delete customer
  const handleDelete = async () => {
    if (!show) return;
    try {
      await fetch(`/customers/delete/${show}/`, {
        method: "DELETE",
      }).then((res) => {
        if (res.ok) {
          window.location.reload();
        }
      });
    } catch (error) {
      console.error("Delete failed", error);
    }
    setShow(false);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}></div>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />
      <div className="page-wrapper customers">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="content-page-header">
              <h5>Customers</h5>
              <div className="list-btn">
                <ul className="filter-list">
                  <li>
                    <Link
                      className="btn btn-primary"
                      to="/customers/add-customer"
                    >
                      <i
                        className="fa fa-plus-circle me-2"
                        aria-hidden="true"
                      />
                      Add Customer
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card customers">
                <div className="card-body">
                  <div className="table-responsive table-hover">
                    <Table
                      className="table"
                      // pagination={{
                      //   total: datasource.length,
                      //   showTotal: (total, range) =>
                      //     `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      //   // showSizeChanger: true,
                      //   onShowSizeChange: onShowSizeChange,
                      //   itemRender: itemRender,
                      // }}
                      columns={columns}
                      dataSource={datasource}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade"
        id="delete_modal"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>Delete Customer</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <button
                      type="reset"
                      data-bs-dismiss="modal"
                      className="w-100 btn btn-primary paid-continue-btn"
                      onClick={handleDelete}
                    >
                      Delete
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="w-100 btn btn-primary paid-cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Customers;
